type RouterLocation = { route?: string | null } | null | undefined;

/**
 * The compose-app-router pattern the current location matched, from the `routes`
 * map in routes/index.ts (`/stories/:entitySubdomain/story/:storyId`). Pageviews
 * send this, never the raw pathname, so record ids do not become extra routes.
 * The optional trailing-slash group `(/)` is dropped: it is not part of the page.
 */
export function storiesRoutePattern(location: RouterLocation): string | undefined {
  const route = location?.route;
  if (typeof route !== 'string' || route.length === 0) return undefined;

  const pattern = route.replace(/\(\/\)$/, '').replace(/\/+$/, '');
  return pattern.length > 0 ? pattern : '/';
}
